import React, { useEffect, useState } from 'react';
import moment from 'moment';
import { useAuthentication } from '../../../../hooks/useAuthentication';
import * as api from '../../../../services/apis';
import InvoicesList from './InvoicesList';

const InvoiceListContainer = () => {
  const [renderedInvoices, setRenderedInvoices] = useState([]);
  const [originalInvoices, setOriginalInvoices] = useState([]);
  const [tableLoading, setTableLoading] = useState(true);
  const [invoiceType, setInvoiceType] = useState('SALES');
  const [lastUpdated, setLastUpdated] = useState(null);

  const { logout, userInfo } = useAuthentication();

  const getInvoicesList = (view, taxNumber, filters) => {
    api
      .getInvoiceViewInvoiceList({ view, vatNumber: taxNumber }, filters)
      .then((resp) => {
        // Transform data to add issueTime field from issueDate unix timestamp
        const transformedData = (resp?.data || []).map((invoice) => ({
          ...invoice,
          issueTime: invoice.issueDate
            ? moment.unix(invoice.issueDate).format('HH:mm:ss')
            : null,
        }));
        setOriginalInvoices(transformedData);
        setRenderedInvoices(transformedData);
        setLastUpdated(moment());
        setTableLoading(false);
      })
      .catch((err) => {
        if (err?.status === 401) {
          // eslint-disable-next-line no-undef
          logout({ redirect: location.pathname });
        }
        setTableLoading(false);
      });
  };

  useEffect(() => {
    if (userInfo) {
      getInvoicesList(invoiceType, userInfo.tax_number);
    }
  }, [userInfo, invoiceType]);

  const handleRefresh = () => {
    if (userInfo) {
      setTableLoading(true);
      getInvoicesList(invoiceType, userInfo.tax_number);
    }
  };
  const onReset = () => {
    handleRefresh();
  };

  const handleSubmitFilters = (data) => {
    setTableLoading(true);
    getInvoicesList(invoiceType, userInfo.tax_number, {
      startIssueDate: data.issueDateFrom,
      endIssueDate: data.issueDateTo,
      vatNumber: data.vatAccountNumber,
      vatType: '',
      fromVatAmount: data.vatMinAmount,
      toVatAmount: data.vatMaxAmount,
      fromGrossAmount: data.grossMinAmount,
      toGrossAmount: data.grossMaxAmount,
      invoiceNumber: data.invoiceNumber,
      subType: data.invoiceSubType,
      invoiceType: [],
      specialScenario: data.transactionType,
      generatedBy: data.generatedBy,
    });
  };

  return (
    <InvoicesList
      renderedInvoices={renderedInvoices}
      originalInvoices={originalInvoices}
      setInvoicesList={setRenderedInvoices}
      tableLoading={tableLoading}
      invoiceType={invoiceType}
      setInvoiceType={setInvoiceType}
      lastUpdated={lastUpdated}
      onRefresh={handleRefresh}
      onReset={onReset}
      handleSubmitFilters={handleSubmitFilters}
    />
  );
};

export default InvoiceListContainer;
